import React from "react";
import i18n from "i18next";

const RestrictedViewIcon = ({ color }:any) => {
  return (
    <div className="box_name_icons" style={{ borderColor: color }}>
      <p style={{ color: color }}>
        <span className="icon-restricted-view"></span>
        <span>{i18n.t("tooltipSeat.restrictedView")}</span>
      </p>
    </div>
  );
};

const AccesibleIcon = ({ color }:any) => (
  <div className="box_name_icons" style={{ borderColor: color }}>
    <p style={{ color: color }}>
      <span className="icon-accesible"></span>
      <span>{i18n.t("tooltipSeat.accessible")}</span>
    </p>
  </div>
);

const CompanionIcon = ({color}:any) => (
  <div className="box_name_icons" style={{ borderColor: color }}>
    <p style={{ color: color }}>
      <span className="icon-companion"></span>
      <span>{i18n.t("tooltipSeat.companion")}</span>
    </p>
  </div>
);

export const TooltipIcons = ({target}:any) => {
  return<>
    {target.restrictedView && <RestrictedViewIcon color={target.category.color} />}
    {target.accesible && <AccesibleIcon color={target.category.color} />}
    {target.companion && <CompanionIcon color={target.category.color}/>}
  </>
}
